import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import watch from './attrs/watch'

import Autocomplete from 'vuejs-auto-complete'

export default {
    name: 'AgencyReservations',
    created,
    data,
    methods,
    watch,
    components: {
        Autocomplete
    }
}
